module.exports = __webpack_public_path__ + "img/user-racer.d4bc5172.png";